import loadable from '@loadable/component';

export const MbySiteWrapper = loadable(
  () => import(/* webpackChunkName: "mby-site" */ './MbySiteWrapper'),
);
